export default __webpack_public_path__ + "static/9-a664679c4426c7ad6e8cd076973548c9.webp";